import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { fetchCaseStudy } from '@/lib/api';

export default function CaseStudyDetail() {
  const { slug } = useParams();
  const [study, setStudy] = useState(null);
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    setStudy(null);
    setNotFound(false);
    fetchCaseStudy(slug)
      .then(setStudy)
      .catch(() => setNotFound(true));
  }, [slug]);

  if (notFound) {
    return (
      <section className='py-12 md:py-16 xl:py-20 border-b border-[#1a1a1a] hero-grid diag-lines inner-hero'>
          <div className="container-r360 py-32 text-center">
            <div className="accent font-display text-[72px] font-extrabold leading-none">CASE STUDY NOT FOUND</div>
            <Link to="/case-studies" className="btn btn-outline-alt mt-6 inline-flex">← Back to case studies</Link>
          </div>
      </section>
    );
  }

  if (!study) return <div className="container-r360 py-20 mono-label">LOADING…</div>;

  return (
     <section className='py-12 md:py-16 xl:py-20  border-b border-[#1a1a1a] hero-grid diag-lines inner-hero'>
    <div className="container-r360 py-20" data-testid="case-study-detail">
      <Link to="/case-studies" className="font-display uppercase font-medium hover:text-[#ff5117] pb-1 border-b border-[#f0f0f0] hover:border-[#ff5117]" data-testid="back-cs">← All Case Studies</Link>
      <div className="mt-10">
         <div className="highlights-kicker text-blue">
            <span />
            Vertical: {study.industry}
          </div>
        <h1 className="font-display font-bold leading-[0.92] tracking-[-0.035em] text-[4rem] md:text-[4.75rem] lg:text-[5.75rem] xl:text-[7rem]">
          {study.brand}
        </h1>
        <p className="reveal-on-scroll text-[20px] sm:text-[26px] text-[#c9c9c9] max-w-3xl mt-4">{study.headline}</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-0 border-t border-l border-[#1a1a1a] mt-8">
        {study.metrics.map((m, i) => (
          <div key={i} className="border-r border-b border-[#1a1a1a] p-4 md:p-6 xl:p-10 bg-white/10">
            <div className="accent font-display text-[2.5rem] lg:text-[3.5rem] xl:text-[4.5rem] font-extrabold leading-none">{m.value}</div>
            <div className="uppercase font-bold mt-2 lg:mt-4">{m.label}</div>
          </div>
        ))}
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-4 lg:gap-12 mt-12 xl:mt-20">
        <div className="lg:col-span-4">
          <div className="highlights-kicker text-white">
            <span />
            CHALLENGE & APPROACH
          </div>
          <div className="flex flex-wrap gap-2">
            {study.tags.map((t, i) => (
              <span key={i} className="uppercase text-green font-bold text-[24px] lg:text-[32px]">{t}</span>
            ))}
          </div>
        </div>
        <div className="lg:col-span-8">
          <p className="reveal-on-scroll text-[17px] leading-[1.8] text-[#f0f0f0]">{study.body}</p>
          <div className="flex flex-wrap gap-4 mt-4 md:mt-6 lg:mt-8">
            <Link to="/book-a-demo" className="btn btn-primary">Get a similar plan →</Link>
            <Link to="/case-studies" className="btn btn-outline">Read another study</Link>
          </div>
        </div>
      </div>
    </div>
    </section>
  );
}
